import { Grid, makeStyles, Typography } from "@material-ui/core"
import RoundedButton from "../../../../../components/Actions/RoundedButton"
import InputForm from "../../../../../components/Forms/InputForm"
import SimpleModal from "../../../../../components/Modals/SimpleModal"
import DisplayError from "../../../../../components/Structure/DisplayData/DisplayError"
import Header from "../../../../../components/Structure/Texts/Header"
import system_translations from "../../../../../texts/system_translations"
import useEditPurchaseGroupModal from "./useEditPurchaseGroupModal"



const EditPurchaseGroupModal = ({open, onClose, language, onCompleted, origin}) => {

    const classes = useStyles()
    const content = system_translations[language].modals.purchase_group_modal
    const {loading, sending, error, form, actions} = useEditPurchaseGroupModal({open, language, content, onCompleted, onClose, origin})

    return(
        <SimpleModal open={open} onClose={onClose} maxWidth='xs' loading={loading} >
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant='h6'>{content.edit.title}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Header>{content.form.name.tag}</Header>
                    <InputForm data={form.name} onChange={actions.onChangeForm} />     
                </Grid>
                <Grid item xs={12}>
                    <Header>{content.form.description.tag}</Header>
                    <InputForm data={form.description} onChange={actions.onChangeForm} />     
                </Grid>
            </Grid>
            <div className={classes.button_container}>
                <DisplayError>{error}</DisplayError>
                <RoundedButton onClick={actions.onSubmit} loading={sending}>{content.edit.button}</RoundedButton>
            </div>
        </SimpleModal>
    )

}

export default EditPurchaseGroupModal

const useStyles = makeStyles(theme => ({
    contact_info:{
        padding:'0px 40px'
    },
    button_container:{
        textAlign:'center',
        margin:'40px 0px 0px'
    },
    contact_title:{
        color:theme.palette.primary.dark,
        padding:'20px 0px'
    },
    line:{
        width:'100%',
        height:1,
        background:'rgba(179, 10, 16, 0.26)',
        marginLeft:4
    }
    
    
    
}))